// extracted by mini-css-extract-plugin
export default {"listContainer":"styles_listContainer__7QMs3","accidentCard":"styles_accidentCard__G2xo0","iconButton":"styles_iconButton__VNlGz"};